export const isAdditionalTermCompatible = (additional, option) => {
  if (!option || !option.incompatibleServices) {
    return false;
  }

  return !option.incompatibleServices.includes(additional.id);
};
